import {utilModule} from '../module.js';

utilModule.directive('nsSelectOnClick', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            element.on('click', function () {
                this.setSelectionRange(0, this.value.length);
            });
        }
    };
});
